import React from "react"
import { IlloUnderwaterDesktop } from "../atoms/Illustrations"
import { useAuthentication } from "#/components/context/authentication/AuthenticationProvider"
import { PiiText } from "#/services/tracking"
import { FormattedMessage } from "react-intl"
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link
} from "@carrotfertility/carotene-core"
import { DialogActionsBar } from "@carrotfertility/carotene-core-x"
import { useMemberBenefitStarted, useMemberName } from "#/services/user/derived-selectors/member-info"
import { auto } from "#/services/locale/bidirectional-text"

const BenefitNotStartedContainer = (): JSX.Element => {
  const benefitStartedQuery = useMemberBenefitStarted()
  const memberNameQuery = useMemberName()

  if (benefitStartedQuery.isLoading || memberNameQuery.isLoading) {
    return null
  }

  return benefitStartedQuery.data ? null : <BenefitNotStartedDialog memberName={memberNameQuery?.data} />
}

const BenefitNotStartedDialog = ({ memberName }: { memberName: string }): JSX.Element => {
  const { handleSignOut } = useAuthentication()

  const handleSignOutClick = () => {
    handleSignOut()
  }

  return (
    <Dialog
      aria-labelledby="benefit-not-started-modal-title"
      aria-describedby="benefit-not-started-modal-description"
      open
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          paddingBlock: (theme) => theme.spacing(theme.tokens.spacing.xl)
        }}
      >
        <IlloUnderwaterDesktop className={null} />
      </Box>
      <DialogTitle id="benefit-not-started-modal-title">
        <FormattedMessage
          defaultMessage="You're all set for now, <pii>{memberName}</pii>"
          values={{ memberName: auto(memberName), pii: (piiContent) => <PiiText>{piiContent}</PiiText> }}
        />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="benefit-not-started-modal-description">
          <FormattedMessage
            defaultMessage="We'll email you when your benefit is available. In the meantime, <link>reach out to your Care Team</link> if you have any questions. We're here to help."
            values={{
              link: (linkContent) => <Link href="https://www.get-carrot.com/employee-support">{linkContent}</Link>
            }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActionsBar
        primaryAction={
          <Button variant="contained" color="primary" onClick={handleSignOutClick}>
            <FormattedMessage defaultMessage="Sign out" />
          </Button>
        }
      />
    </Dialog>
  )
}

export { BenefitNotStartedContainer }
